import constants from '../../../constants';
import { getInstance } from '../../../lib/axios';

export async function GetUserTrainingsPerActivity(id) {
  try {
    const url = `${constants.endpoints.USER_STATISTICS}/perUsersActivity/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Users statistics fetch failed', error.message);
    throw error;
  }
}

export async function GetUserTrainingsPerDayAndMonthStatistics(id) {
  try {
    const url = `${constants.endpoints.USER_STATISTICS}/perDayAndMonth/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Users statistics fetch failed', error.message);
    throw error;
  }
}

export async function GetUserWorkoutsStatistics(id) {
  try {
    const url = `${constants.endpoints.USER_STATISTICS}/workouts/user/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Users workouts statistics fetch failed', error.message);
    throw error;
  }
}